import React, {useEffect } from 'react';
import clsx from 'clsx';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import {
  Card,
  CardActions,
  CardHeader,
  CardContent,
  Button,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,


} from '@mui/material';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';


import { StatusBullet } from 'components';


import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchTodayOrders } from 'store/actions/restaurant';

import API from 'util/API';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 800
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  status: {
    marginRight: theme.spacing(1)
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const statusColors = {
  delivered: 'success',
  pending: 'info',
  refunded: 'danger'
};



const LatestOrders = props => {
  const { className, ...rest } = props;
  const dispatch = useDispatch();

  const classes = useStyles();

  const orders = useSelector((state) => state.restaurant.todayOrders);
  const orderType = useSelector((state) => state.restaurant.orderType);
  const loadTodayOrders= (orders) => dispatch(fetchTodayOrders(orders));
  const history = useHistory();


  const fectchOrders = (type) => {
    // authMiddleWare(history);
    // const authToken = localStorage.getItem('AuthToken');
    // instance.defaults.headers.common['Authorization'] = authToken;

    API
      .get('/todayOrder?type=' + type)
      .then((response) => {
        //console.log('response.data', response.data);
        loadTodayOrders(response.data)
 
      })
      .catch((error) => {
        console.log(error);

        if (error.response && error.response.status === 403) {
          history.push('/sign-in');
        }
           
        

      });
  };

  useEffect(() => {
    fectchOrders(orderType);
  }, [orderType]);

  const getOrderTotal = (order) => {
    const total =order.order.items.reduce((count, curItem) => {
      return count + curItem.quantity * curItem.subTotal;
  }, 0);
  return total.toFixed(2).toString();
  };

  const orderCreateTime = (order) => {
    if ('_seconds' in order.createdAt) {
      return  moment(new Date(order.createdAt._seconds * 1000)).format('DD/MM/YYYY HH:mm:ss')
    }
    return moment(order.createdAt).format('DD/MM/YYYY HH:mm:ss')
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        action={
          <Button
            color="primary"
            size="small"
            variant="outlined"
          >
            New entry
          </Button>
        }
        title="Latest Orders"
      />
      <Divider />
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Order No</TableCell>
                  <TableCell>Customer</TableCell>
                  <TableCell >
                   
                        Time
                
                  </TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orders && orders.map(order => (
                  <TableRow
                    hover
                    key={order.id}
                  >
                    <TableCell>{order.id}</TableCell>
                    <TableCell>{order.user && order.user.name}(${getOrderTotal(order)})</TableCell>
                    <TableCell>
                    {orderCreateTime(order)}
                    </TableCell>
                    <TableCell>
                      <div className={classes.statusContainer}>
                        <StatusBullet
                          className={classes.status}
                          color={statusColors[order.status]}
                          size="sm"
                        />
                        {order.status}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <Divider />
      <CardActions className={classes.actions}>
        <Button
          color="primary"
          size="small"
          variant="text"
        >
          View all <ArrowRightIcon />
        </Button>
      </CardActions>
    </Card>
  );
};

LatestOrders.propTypes = {
  className: PropTypes.string
};

export default LatestOrders;
